
import { ref, shallowRef, computed } from '@vue/composition-api';
import { layoutDrawerAction } from '@/model/action';
import { isNil } from 'lodash';
import { createEventHook } from '@vueuse/core';

export const useLayoutAction = () => {
  const action = shallowRef<layoutDrawerAction | null>(null);
  const visible = ref<boolean>(false);

  const showDrawer = (param: layoutDrawerAction) => {
    if (isNil(param.projectId) || isNil(param.issueType)) {
      console.error('Missing parameters: projectId or issueType');
      return;
    }

    action.value = {
      projectName: 'Projects',
      projectColor: '#FF8384',
      ...param
    };
    visible.value = true;
  };

  const closeEventHook = createEventHook<{
    action: layoutDrawerAction | null;
  }>();

  const closeDrawer = () => {
    closeEventHook.trigger({
      action: action.value
    });
    visible.value = false;
    action.value = null;
  };

  return {
    action,
    drawerVisible: computed(() => visible.value),
    showDrawer,
    closeDrawer,
    onClose: closeEventHook.on
  };
};

export type ActionStore = ReturnType<typeof useLayoutAction>;